{
  "loading": "Loading...",
  "error": "Error",
  "cancel": "Cancel",
  "confirm": "Confirm",
  "save": "Save",
  "edit": "Edit",
  "delete": "Delete",
  "deleting": "Deleting...",
  "create": "Create",
  "update": "Update",
  "search": "Search",
  "filter": "Filter",
  "sort": "Sort",
  "export": "Export",
  "import": "Import",
  "refresh": "Refresh",
  "back": "Back",
  "next": "Next",
  "previous": "Previous",
  "close": "Close",
  "open": "Open",
  "view": "View",
  "download": "Download",
  "upload": "Upload",
  "signOut": "Sign out",
  "roles": {
    "practitioner": "Practitioner",
    "institution": "Institution",
    "admin": "Administrator",
    "unknown": "Unknown"
  },
  "ui": {
    "avatar": "Avatar",
    "pagination": {
      "label": "pagination",
      "goToPrevious": "Go to previous page",
      "goToNext": "Go to next page",
      "morePages": "More pages"
    },
    "sidebar": {
      "title": "Sidebar",
      "description": "Displays the mobile sidebar.",
      "toggle": "Toggle Sidebar"
    },
    "breadcrumb": {
      "label": "breadcrumb",
      "more": "More"
    },
    "command": {
      "title": "Command Palette",
      "description": "Search for a command to run..."
    },
    "imageUpload": {
      "placeholder": "Click to upload image",
      "invalidFile": "Invalid file",
      "preview": "Preview",
      "hint": "PNG, JPG, JPEG, WEBP (max 2MB)"
    },
    "markdownEditor": {
      "placeholder": "Write your content here...",
      "loading": "Loading editor..."
    }
  },
  "mobileAppInfo": {
    "title": "Evaluations are run from the mobile app",
    "description": "Evaluations are carried out in the MetaDevProfile mobile application (phone or tablet). The web space lets you view your patients, results and resources.",
    "appStore": "App Store",
    "googlePlay": "Google Play"
  },
  "notFound": {
    "title": "Page not found",
    "description": "The page you are looking for does not exist.",
    "backToHome": "Back to home"
  },
  "routeError": {
    "title": "Something went wrong",
    "description": "An unexpected error occurred. Please try again.",
    "retry": "Retry"
  },
  "errors": {
    "unknownError": "An unknown error occurred",
    "tryAgain": "Please try again",
    "tryRefreshing": "Please try refreshing the page",
    "checkInfoAndRetry": "Please check your information and try again",
    "sendMessageFailed": "Failed to send message",
    "sendFeedbackFailed": "Failed to send feedback"
  }
}
